import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteGlcChamber,
  getGlcChamber,
  glcReportRemoval,
  updateGlcChamber,
  uploadGLCReport,
} from "../../redux/actions/glc_action";
import SectionTitle from "../../common/shared/SectionTitle";
import AlertMessage from "../../common/actions/AlertMessage";
import Loader from "../../common/loader/Loader";
import RejectIconButton from "../../common/buttons/RejectIconButton";
import AcceptIconButton from "../../common/buttons/AcceptIconButton";
import CalenderIconButton from "../../common/buttons/CalenderIconButton";
import UploadIconButton from "../../common/buttons/UploadIconButton";
import DataTable from "../../common/shared/DataTable";
import FilesIconButton from "../../common/buttons/FilesIconButton";
import { CHAMBER_DATA } from "../../constants/constants";
import OpenModal from "../../common/actions/OpenModal";
import { Typography } from "@material-tailwind/react";
import DatePickerComp from "../../common/forms/DatePicker";
import FileUpload from "../../common/forms/FileUpload";
import InputArea from "../../common/forms/InputArea";
import DeleteIconButton from "../../common/buttons/DeleteIconButton";
import ViewButton from "../../common/buttons/ViewButton";
import DetailItem from "../../common/shared/DetailItem";
import listArrayObject from "../../utils/listArrayObject";
import moment from "moment";
import RemovalButton from "../../common/buttons/RemovalButton";

const link = [{ name: "Chamber Application", link: "" }];

function GlcChamber() {
  const [loading, setLoading] = useState(true);
  const [approveLoading, setApproveLoading] = useState(false);
  const [dateLoading, setDateLoading] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [confirmModal, setConfirmModal] = useState(false);
  const [dateModal, setDateModal] = useState(false);
  const [fileUpload, setFileUpload] = useState(false);
  const [filesModal, setFilesModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [detailModal, setDetailModal] = useState(false);

  const [formData, setFormData] = useState(CHAMBER_DATA);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const dispatch = useDispatch();

  const { data, glcError, glcSuccess } = useSelector((state) => state.glc);

  const currentDate = new Date();
  let nextDay = currentDate.setDate(currentDate.getDate());

  const handleDetailsModal = (params) => {
    setDetailModal(!detailModal);
    setFormData(params);
  };

  const handleReportRemoval = (params) => {
    dispatch(glcReportRemoval({ id: params.id })).finally(() =>
      window.location.reload()
    );
  };

  const columns = [
    {
      field: "name",
      headerName: "Chamber Name",
      flex: 1,
      renderCell: (params) => {
        const rejectValue = params?.row?.rejected_note;
        const rejectedAt = params?.row?.rejected;
        const updatedAt = params?.row?.updatedAt;

        const formattedRejectedAt = moment(rejectedAt).format("YYYY-MM-DD");
        const formattedUpdatedAt = moment(updatedAt).format("YYYY-MM-DD");

        const isRejectedAtEqualToUpdatedAt =
          formattedRejectedAt === formattedUpdatedAt;

        return (
          <span
            className={`${
              params?.row?.stage === 2
                ? "text-blue-500"
                : params?.row?.stage === 3
                ? "text-green-500"
                : rejectValue !== null && isRejectedAtEqualToUpdatedAt
                ? "text-red-500"
                : params?.row?.stage === 4
                ? "text-orange-500"
                : "text-black"
            }`}
          >
            {params.row.name.toUpperCase()}
          </span>
        );
      },
    },
    {
      field: "head",
      headerName: "Head",
      flex: 1,
      renderCell: (params) => {
        const rejectValue = params?.row?.rejected_note;
        const rejectedAt = params?.row?.rejected;
        const updatedAt = params?.row?.updatedAt;

        const formattedRejectedAt = moment(rejectedAt).format("YYYY-MM-DD");
        const formattedUpdatedAt = moment(updatedAt).format("YYYY-MM-DD");

        const isRejectedAtEqualToUpdatedAt =
          formattedRejectedAt === formattedUpdatedAt;

        return (
          <div className="flex flex-col">
            <span
              className={`${
                params?.row?.stage === 2
                  ? "text-blue-500"
                  : params?.row?.stage === 3
                  ? "text-green-500"
                  : rejectValue !== null && isRejectedAtEqualToUpdatedAt
                  ? "text-red-500"
                  : params?.row?.stage === 4
                  ? "text-orange-500"
                  : "text-black"
              }`}
            >
              {params.row.headOf.first_name + " " + params.row.headOf.last_name}
            </span>
            <span
              className={`${
                params?.row?.stage === 2
                  ? "text-blue-500"
                  : params?.row?.stage === 3
                  ? "text-green-500"
                  : rejectValue !== null && isRejectedAtEqualToUpdatedAt
                  ? "text-red-500"
                  : params?.row?.stage === 4
                  ? "text-orange-500"
                  : "text-black"
              }`}
            >
              Bar #: {params.row.headOf.bar_number}
            </span>
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Stage",
      flex: 1,
      renderCell: (params) => {
        const rejectValue = params?.row?.rejected_note;
        const rejectedAt = params?.row?.rejected;
        const updatedAt = params?.row?.updatedAt;

        const formattedRejectedAt = moment(rejectedAt).format("YYYY-MM-DD");
        const formattedUpdatedAt = moment(updatedAt).format("YYYY-MM-DD");

        const isRejectedAtEqualToUpdatedAt =
          formattedRejectedAt === formattedUpdatedAt;

        return (
          <span
            className={`${
              params?.row?.stage === 2
                ? "text-blue-500"
                : params?.row?.stage === 3
                ? "text-green-500"
                : rejectValue !== null && isRejectedAtEqualToUpdatedAt
                ? "text-red-500"
                : params?.row?.stage === 4
                ? "text-orange-500"
                : "text-black"
            }`}
          >
            {params.row.chamber_status.name}
          </span>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Date",
      width: 120,
      renderCell: (params) => {
        const rejectValue = params?.row?.rejected_note;
        const rejectedAt = params?.row?.rejected;
        const updatedAt = params?.row?.updatedAt;

        const formattedRejectedAt = moment(rejectedAt).format("YYYY-MM-DD");
        const formattedUpdatedAt = moment(updatedAt).format("YYYY-MM-DD");

        const isRejectedAtEqualToUpdatedAt =
          formattedRejectedAt === formattedUpdatedAt;

        return (
          <span
            className={`${
              params?.row?.stage === 2
                ? "text-blue-500"
                : params?.row?.stage === 3
                ? "text-green-500"
                : rejectValue !== null && isRejectedAtEqualToUpdatedAt
                ? "text-red-500"
                : params?.row?.stage === 4
                ? "text-orange-500"
                : "text-black"
            }`}
          >
            {params.row.createdAt}
          </span>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 160,
      className: "frozen-column",
      renderCell: (params) => (
        <div>
          {params.row.stage === 1 ? (
            <AcceptIconButton onClick={() => confirmApprove(params.row)} />
          ) : params.row.stage === 2 && !params.row.inspect_date ? (
            <CalenderIconButton onClick={() => showDate(params.row)} />
          ) : params.row.stage === 2 && params.row.inspect_date ? (
            <UploadIconButton onClick={() => openUpload(params.row)} />
          ) : params.row.stage === 3 ? (
            <AcceptIconButton onClick={() => confirmApprove(params.row)} />
          ) : null}
          {params.row.stage !== 5 && (
            <>
              <FilesIconButton onClick={() => showFiles(params.row)} />
              {params.row.stage === 4 ? (
                <DeleteIconButton onClick={() => showDelete(params.row)} />
              ) : (
                <RejectIconButton onClick={() => openReject(params.row)} />
              )}
            </>
          )}

          {params.row.stage > 2 && (
            <RemovalButton onClick={() => handleReportRemoval(params.row)} />
          )}

          <ViewButton onClick={() => handleDetailsModal(params)} />
        </div>
      ),
    },
  ];

  const updateFormValue = ({ updateType, value }) => {
    setFormData({ ...formData, [updateType]: value });
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const confirmApprove = (item) => {
    setConfirmModal(!confirmModal);
    setFormData(item);
  };

  const showDate = (item) => {
    setDateModal(!dateModal);
    setFormData(item);
  };

  const showDelete = (item) => {
    setDeleteModal(!deleteModal);
    setFormData(item);
  };

  const showFiles = (item) => {
    setFilesModal(!filesModal);
    setFormData(item);
  };

  const openUpload = (item) => {
    setFileUpload(!fileUpload);
    setFormData(item);
  };

  const openReject = (item) => {
    setFormData(item);
    setRejectModal(!rejectModal);
  };

  const handleApprove = () => {
    setApproveLoading(true);
    const approveData = {
      id: formData.id,
      stage: ++formData.stage,
    };
    dispatch(updateGlcChamber(approveData)).finally(() => {
      setConfirmModal(false);
      setApproveLoading(false);
    });
  };

  const handleDateInspection = () => {
    setDateLoading(true);
    const dateData = {
      id: formData.id,
      inspect_date: selectedDate.toISOString(),
    };
    dispatch(updateGlcChamber(dateData)).finally(() => {
      setDateModal(false);
      setDateLoading(false);
    });
  };

  const handleDelete = () => {
    setDeleteLoading(true);

    dispatch(deleteGlcChamber(formData.id)).finally(() => {
      setDeleteModal(false);
      setDeleteLoading(false);
    });
  };

  const handleFileUpload = async (file) => {
    setFileLoading(true);
    const id = formData.id;
    dispatch(uploadGLCReport(id, file)).finally(() => {
      setFileUpload(!fileUpload);
      setFileLoading(false);
    });
  };

  const handleReject = (e) => {
    e.preventDefault();
    setRejectLoading(true);
    const rejectData = {
      id: formData.id,
      rejected: new Date(),
      rejected_note: formData.rejected_note,
    };
    dispatch(updateGlcChamber(rejectData)).finally(() => {
      setRejectModal(false);
      setRejectLoading(false);
    });
  };

  useEffect(() => {
    dispatch(getGlcChamber()).finally(() => setLoading(false));
  }, [dispatch]);

  return (
    <>
      <SectionTitle
        title="Chamber Application"
        description=""
        children={link}
      />

      <div className="my-8 max-w-[1200px] m-auto px-4">
        {glcError ? (
          <AlertMessage type="error" message={glcError} />
        ) : glcSuccess ? (
          <AlertMessage type="success" message={glcSuccess} />
        ) : null}

        {loading ? (
          <Loader />
        ) : (
          <>
            <DataTable
              rows={data}
              columns={columns}
              dateFormat={["createdAt"]}
              pageSize={10}
            />

            {confirmModal && (
              <OpenModal
                open={confirmModal}
                handler={confirmApprove}
                title="Confirm Approval"
                loading={approveLoading}
                actionTitle="Confirm"
                handleSubmit={(e) => handleApprove(e)}
                children={
                  <Typography color="black" variant="paragraph">
                    Please confirm you want to approve{" "}
                    <strong>{formData.name}</strong> application?
                  </Typography>
                }
              />
            )}

            {dateModal && (
              <OpenModal
                open={dateModal}
                handler={showDate}
                title="Inpection Date"
                loading={dateLoading}
                actionTitle="Save Date"
                handleSubmit={handleDateInspection}
                children={
                  <DatePickerComp
                    label=""
                    selectedDate={selectedDate}
                    onSelectDate={handleDateChange}
                    minDate={nextDay}
                  />
                }
              />
            )}

            {fileUpload && (
              <OpenModal
                open={fileUpload}
                handler={openUpload}
                title="Upload Report"
                loading={fileLoading}
                actionTitle=""
                // handleSubmit={() => setFileUpload(!fileUpload)}
                children={
                  <FileUpload
                    label="Report"
                    onUpload={(file) => handleFileUpload(file)}
                    loading={fileLoading}
                  />
                }
              />
            )}

            {filesModal && (
              <OpenModal
                open={filesModal}
                handler={showFiles}
                title="Uploaded Documemnts"
                children={
                  <>
                    {formData.files?.reg && (
                      <div className="mb-6">
                        <Typography color="black" variant="small">
                          Registration Document
                        </Typography>
                        <a
                          href={`https://gbafilesalt.blob.core.windows.net/storage/${formData.files?.reg}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {formData.files?.reg}
                        </a>
                      </div>
                    )}

                    {formData.files?.vat && (
                      <div className="mb-6">
                        <Typography color="black" variant="small">
                          VAT Document
                        </Typography>
                        <a
                          href={`https://gbafilesalt.blob.core.windows.net/storage/${formData.files?.vat}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {formData.files?.vat}
                        </a>
                      </div>
                    )}

                    {formData.files?.ssnit && (
                      <div className="mb-6">
                        <Typography color="black" variant="small">
                          SSNIT Document
                        </Typography>
                        <a
                          href={`https://gbafilesalt.blob.core.windows.net/storage/${formData.files?.ssnit}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {formData.files?.ssnit}
                        </a>
                      </div>
                    )}

                    {formData.files?.evidence && (
                      <div className="mb-6">
                        <Typography color="black" variant="small">
                          Evidence of Client's Account
                        </Typography>
                        <a
                          href={`https://gbafilesalt.blob.core.windows.net/storage/${formData.files?.evidence}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {formData.files?.evidence}
                        </a>
                      </div>
                    )}

                    <hr className="my-4" />

                    {formData.reports ? (
                      <div className="mb-6">
                        <Typography color="black" variant="small">
                          Report
                        </Typography>
                        <a
                          href={`https://gbafilesalt.blob.core.windows.net/storage/${formData.reports}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {formData.reports}
                        </a>
                      </div>
                    ) : (
                      <Typography color="black" variant="lead">
                        No Report Uploaded
                      </Typography>
                    )}
                  </>
                }
              />
            )}

            {rejectModal && (
              <OpenModal
                open={rejectModal}
                handler={openReject}
                title="Reject Application"
                loading={rejectLoading}
                actionTitle="Proceed"
                handleSubmit={(e) => handleReject(e)}
                children={
                  <InputArea
                    defaultValue={formData?.rejected_note}
                    updateType="rejected_note"
                    labelTitle="Reason"
                    updateFormValue={updateFormValue}
                    required={true}
                  />
                }
              />
            )}

            {deleteModal && (
              <OpenModal
                open={deleteModal}
                handler={showDelete}
                title="Confirm Deletion"
                loading={deleteLoading}
                actionTitle="Delete"
                children={
                  <Typography color="black" variant="paragraph">
                    Please confirm you want to delete{" "}
                    <strong>{formData.name}</strong> ?
                  </Typography>
                }
                handleSubmit={(e) => handleDelete(e)}
              />
            )}

            {detailModal && (
              <OpenModal
                containerStyle="max-w-5xl modal-shift"
                title="Chamber Details"
                size="xl"
                open={detailModal}
                handler={handleDetailsModal}
                children={
                  <>
                    <div className="grid grid-cols-3 gap-4 my-4">
                      <DetailItem
                        title="Name"
                        item={formData?.row?.name}
                        containerStyle="col-span-2"
                      />
                      <DetailItem title="Type" item={formData?.row?.type} />
                    </div>

                    <div className="grid grid-cols-3 gap-4 my-4">
                      <DetailItem
                        title="Chamber Head"
                        item={
                          formData?.row?.headOf.first_name +
                          " " +
                          formData?.row?.headOf.last_name +
                          " - " +
                          formData?.row?.headOf.bar_number
                        }
                      />
                      <DetailItem title="Email" item={formData?.row?.email} />
                      <DetailItem
                        title="Phone #"
                        item={formData?.row?.telephone}
                      />
                    </div>

                    <div className="grid grid-cols-3 gap-4 my-4">
                      <DetailItem title="Fax" item={formData?.row?.fax} />

                      <DetailItem
                        title="Region"
                        item={formData?.row?.region?.name}
                      />
                      <DetailItem title="City" item={formData?.row?.city} />
                    </div>

                    <div className="grid grid-cols-3 gap-4 my-4">
                      <DetailItem
                        title="Postal Address"
                        item={formData?.row?.postal_add}
                      />
                      <DetailItem
                        title="Street Name/House Number"
                        item={formData?.row?.address}
                      />
                      <DetailItem
                        title="Ghana Post GPS"
                        item={formData?.row?.ghpost}
                      />
                    </div>
                    <div className="grid grid-cols-4 gap-4 my-4">
                      <DetailItem
                        title="Reg. No. (Act 151, 152, 179)"
                        item={formData?.row?.reg_num}
                      />
                      <DetailItem
                        title="VAT No."
                        item={formData?.row?.vat_num}
                      />
                      <DetailItem
                        title="TIN No."
                        item={formData?.row?.tin_num}
                      />
                      <DetailItem
                        title="SSNIT No"
                        item={formData?.row?.ssnit_num}
                      />
                    </div>

                    <div className="grid grid-cols-4 gap-4 my-4">
                      <DetailItem
                        title="Number of Staff"
                        item={formData?.row?.staff_num}
                      />
                      <DetailItem
                        title="Number of Clerks"
                        item={formData?.row?.clerks_num}
                      />
                      <DetailItem
                        title="Full Time Accounts Pers. No."
                        item={formData?.row?.accounts_full}
                      />
                      <DetailItem
                        title="Part Time Accounts Pers. No."
                        item={formData?.row?.accounts_part}
                      />
                    </div>

                    <div className="flex">
                      {formData?.row?.rejected_note && (
                        <DetailItem
                          title="Rejected Reason"
                          item={formData?.row?.rejected_note}
                        />
                      )}
                    </div>

                    <div className="flex">
                      <DetailItem
                        title="Equipments"
                        item={formData?.row?.equipments}
                      />
                    </div>

                    <div className="flex">
                      <DetailItem
                        title="Practice Areas"
                        item={listArrayObject({
                          arr: formData?.row?.practice_areas,
                          id: "name",
                        })}
                      />
                    </div>
                  </>
                }
                actionLabel="Close"
                onAction={() => setDetailModal(false)}
              />
            )}
          </>
        )}
      </div>
    </>
  );
}

export default GlcChamber;
